<template>
   <app-master>


    <div slot='breadcrumb'>
        <app-breadcrumb>
             <div class="title-box text-left">
                <div class="page-title-heading">
                    <h1 class="title">Contact Us</h1>
                </div><!-- /.page-title-captions -->
                <div class="breadcrumb-wrapper">
                    <span>
                       <router-link to="/" tag="a" > <i class="ti ti-home"></i>&nbsp;&nbsp;Home </router-link>
                    </span>
                    <span class="ttm-bread-sep ttm-textcolor-white">&nbsp;   →  &nbsp;</span>
                    <span class="ttm-textcolor-skincolor">Contact</span>
                </div>  
            </div>
        </app-breadcrumb>
    </div>



      <div slot="main-content">

           <!-- contactbox-section -->
            <section class="ttm-row contact-box-section ttm-bgcolor-grey clearfix">
                <div class="container">
                    <div class="row"><!-- row -->
                        <div class="col-lg-4">
                            <!--  featured-icon-box --> 
                            <div class="featured-icon-box left-icon p-15 ttm-bgcolor-white mb-20">
                                <div class="featured-icon"><!--  featured-icon --> 
                                    <div class="ttm-icon ttm-icon_element-bgcolor-skincolor ttm-icon_element-size-sm">
                                        <i class="flaticon flaticon-phone-call"></i><!--  ttm-icon --> 
                                    </div>
                                </div>
                                <div class="featured-content"><!--  featured-content -->
                                    <div class="featured-title"><!--  featured-title -->
                                        <h5>Phone</h5>
                                    </div>
                                    <div class="featured-desc"><!--  featured-desc -->
                                         <p> +234 906 282 2260  </p>
                                        <p>+234 812 262 7008</p>
                                       
                                    </div>
                                </div>
                            </div><!--  featured-icon-box END -->
                        </div>
                        <div class="col-lg-4">
                            <!--  featured-icon-box --> 
                            <div class="featured-icon-box left-icon p-15 ttm-bgcolor-white mb-20">
                                <div class="featured-icon"><!--  featured-icon --> 
                                    <div class="ttm-icon ttm-icon_element-bgcolor-skincolor ttm-icon_element-size-sm">
                                        <i class="flaticon flaticon-envelope"></i><!--  ttm-icon --> 
                                    </div>
                                </div>
                                <div class="featured-content" style="padding-bottom: 27px"><!--  featured-content -->
                                    <div class="featured-title"><!--  featured-title -->
                                        <h5>Email Us</h5>
                                    </div>
                                    <div class="featured-desc"><!--  featured-desc -->
                                        <p>info@nardus.ng</p>
                                    </div>
                                </div>
                            </div><!--  featured-icon-box END -->
                        </div>
                        <div class="col-lg-4">
                            <!--  featured-icon-box --> 
                            <div class="featured-icon-box left-icon p-15 ttm-bgcolor-white mb-20">
                                <div class="featured-icon"><!--  featured-icon --> 
                                    <div class="ttm-icon ttm-icon_element-bgcolor-skincolor ttm-icon_element-size-sm">
                                        <i class="flaticon flaticon-placeholder"></i><!--  ttm-icon --> 
                                    </div>
                                </div>
                                <div class="featured-content"><!--  featured-content -->
                                    <div class="featured-title"><!--  featured-title -->
                                        <h5>Address</h5>
                                    </div>
                                    <div class="featured-desc"><!--  featured-desc -->
                                        <p>18 Udi street, Wema Terrace, Osborne Foreshore, Ikoyi, Lagos, Nigeria</p>
                                    </div>
                                </div>
                            </div><!--  featured-icon-box END -->
                        </div>
                    </div><!-- row end -->
                </div>
            </section>
            <!-- contactbox-section end -->
            <!-- contactbox-section -->
            <section class="ttm-row contact-form-section clearfix">
                <div class="container">
                    <div class="row"><!-- row -->
                        <div class="col-lg-6">
                            <!-- section title -->
                            <div class="section-title clearfix">
                                <div class="title-header">
                                    <h2 class="title">Contact Us</h2>
                                </div>
                                <div class="heading-seperator">
                                    <span></span>
                                </div>
                            </div><!-- section title end -->
                            <p>Our customer support team is happy to answer your questions. Fill out the form, and we’ll be in touch within the day.</p>
                            <div class="row">
                                <div class="col-md-12">
                                    <!--  featured-icon-box --> 
                                    <div class="featured-icon-box left-icon style9 ttm-bgcolor-white mb-30">
                                        <div class="featured-icon"><!--  featured-icon --> 
                                            <div class="ttm-icon ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                                                <i class="flaticon flaticon-support"></i><!--  ttm-icon --> 
                                            </div>
                                        </div>
                                        <div class="featured-content"><!--  featured-content -->
                                            <div class="featured-title"><!--  featured-title -->
                                                <h5 class="mb-5">24/7 Customer Support</h5>
                                            </div>
                                            <div class="featured-desc"><!--  featured-desc -->
                                                <p>We have an experienced customer support team that responds to inquiries in real time.</p>
                                            </div>
                                            <!-- <a class="ttm-btn ttm-btn-size-sm ttm-btn-color-skincolor btn-inline ttm-icon-btn-right mt-15" href="#">Learn More <i class="fa fa-chevron-right"></i></a> -->
                                        </div>
                                    </div><!--  featured-icon-box END -->
                                </div>
                                <div class="col-md-12">
                                    <!--  featured-icon-box --> 
                                    <div class="featured-icon-box left-icon style9 ttm-bgcolor-white">
                                        <div class="featured-icon"><!--  featured-icon --> 
                                            <div class="ttm-icon ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                                                <i class="flaticon flaticon-lorry"></i><!--  ttm-icon --> 
                                            </div>
                                        </div>
                                        <div class="featured-content"><!--  featured-content -->
                                            <div class="featured-title"><!--  featured-title -->
                                                <h5 class="mb-5">Excellent Delivery Service</h5>
                                            </div>
                                            <div class="featured-desc"><!--  featured-desc -->
                                                <p>A smart nationwide logistics network that guarantees safe and fast delivery.</p>
                                            </div>
                                            <!-- <a class="ttm-btn ttm-btn-size-sm ttm-btn-color-skincolor btn-inline ttm-icon-btn-right mt-15" href="#">Learn More <i class="fa fa-chevron-right"></i></a> -->
                                        </div>
                                    </div><!--  featured-icon-box END -->
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="spacing-6 ttm-bgcolor-grey mt-0 mb-0">
                                <form id="ttm-quote-form" class="row ttm-quote-form clearfix" method="post" action="#">
                                    <div class="col-sm-6 col-md-6">
                                        <div class="form-group">
                                            <input v-model="formData.fullname" type="text" class="form-control with-border bg-white" placeholder="Full Name*" >
                                        </div>
                                    </div>
                                    <div class="col-sm-6 col-md-6">
                                        <div class="form-group">
                                            <input v-model="formData.telephone" type="text" placeholder="Phone Number*" class="form-control with-border bg-white">
                                        </div>
                                    </div>
                                    <div class="col-sm-6 col-md-12">
                                        <div class="form-group">
                                            <input v-model="formData.email" type="text" placeholder="Email Address*" class="form-control with-border bg-white">
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                       
                                       <div class="form-group">
                                            <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <label class="input-group-text" style="color: #92757d; font-size: 0.9rem" for="inputGroupSelect01">Category</label>
                                            </div>
                                            <select class="custom-select" v-model='formData.category'  id="inputGroupSelect01">
                                               <option value="inquiry">Inquiry</option>
                                                 <option value="complain">Complain</option>
                                                 <option value="others">Others</option>
                                            </select>
                                            </div>
                                       </div>
                                        
                                       
                                    </div> 
                                    <div class="col-sm-6 col-md-12">
                                        <div class="form-group">
                                            <input v-model="formData.subject" type="text" placeholder="Subject"  class="form-control with-border bg-white">
                                        </div>
                                    </div>
                                    
                                    <div class="col-sm-12 col-md-12">
                                        <div class="form-group">
                                            <textarea v-model="formData.message" rows="4" placeholder="Write A Message..." required="required" class="form-control with-border bg-white"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="text-left">
                                            <button type="button" ref="loadableButton" id="submit" class="ttm-btn ttm-btn-size-md ttm-btn-bgcolor-darkgrey w-100" @click.prevent="submit('SUBMIT_CONTACT_US_FORM')">
                                                Submit 
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div><!-- row end -->
                </div>
            </section>
            <!-- contactbox-section end -->
           

           
      </div>



   </app-master>
</template>

<script>
// @ is an alias to /src
import Master from "@/components/Master.vue";
import BreadCrumb from "@/components/BreadCrumb.vue";
import {seo} from "../Repositories/seo.js"
import {pick} from "../Repositories/pick.js"
import {vuesax} from "../Repositories/vuesax"

export default {
  name: "Contact",
  mixins : [seo,pick,vuesax],
  components: {
    "app-master" : Master,
    "app-breadcrumb": BreadCrumb
  },
  data(){
      return {
          formData: {
              fullname: '',
              telephone: '',
              email: '',
              category: '',
              subject: '',
              message: '',
          }

      }
  },
  methods:{

    api_params(value) {
        if(value == "SUBMIT_CONTACT_US_FORM"){
            return { ...this.formData, key: this.API_KEY }
        }
    },

    async api_calls(value){

        let response;
        let x = this;




        if(value == "SUBMIT_CONTACT_US_FORM"){

            /** Start loader gif */
          this.showLoading();

          response = await this.$store.dispatch("contact_us_confirm", this.api_params(value));

            /** If response contain status */
            if( response && 'status' in response){
              
                /** If response status is 200 */
                if(response.status == 200){

                    x.showNotif({type: 'success', message: response.data.message });

                    /** Clears all input field */
                    x.clearInputField(x.formData);
                }


                /** If response status is 400 or 404 */
                if(response.status == 400 || response.status == 404){
                  x.showNotif({type: 'warning', message: response.data.message });

                }

                /** If response contains error */
                if(response.data.errors){
                  x.showNotif({type: 'warning', message: response.data.errors });
                  
                }
                
              } 

              /** End loader gif */
              this.hideLoading();
        }

    },

    async submit(value){
        let x = this;
      
        if(value == "SUBMIT_CONTACT_US_FORM"){
           this.api_calls(value);
            
        }

    }
  },

  created(){
      this.seoMetaData('Contact Us' , '');
  }
};
</script>

<style>

    .vs-notifications{
        padding: 5px 15px!important;
    }
</style>
